import React,{useEffect,useState} from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, Spinner,Button,  Input, FormGroup, Label, Form  } from "reactstrap";
import Dropzone from "react-dropzone";
import {httpGet,httpUpload,httpPUT,httpPost} from "../../../../src/common/petitions"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Puestoslist from './model.json'
import { useNavigate } from 'react-router-dom'
import DataLoader from "../../../components/tableData";
import useUpdateCreateAlert from '../../../components/alerts';
import "../tables.scss";
import "../Puestos.scss";


const PuestosCarga = () => {
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');
  const [uploadResult, setUploadResult] = useState(null);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [raise, setRaise] = useState('');
  const [raiseId, setRaiseId] = useState('');
  const [raiseIsnew, setRaiseIsnew] = useState(true);
  const navigate = useNavigate();
  useUpdateCreateAlert(status, message);


  const downloadTemplate = async () => {
    try {
      const response = await fetch("/templates_xls/PRESUPUESTOMAQ_MOD.xlsx");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "PRESUPUESTOMAQ_MOD.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  const uploadFile = async (file) => {
    setIsUploading(true);
    const formdata = new FormData();
    formdata.append("file", file);
    // console.log(file);
    try {
      const response = await httpUpload(`/mod/import`,formdata,navigate);
      setUploadResult(response);
      if (response.status === 200) {
        navigate('/mod/semanal');
      }
    } catch (error) {
      alert(error.message);
      console.error("Error uploading file:", error);
    }finally {
      setIsUploading(false);
    }
  };


  const handleAcceptedFiles = (files) => {
    const file = files[0];
    uploadFile(file);
  };


  
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const rowsData = await httpGet(`/mod/puestos`,navigate);
        const jsonData = { "columns": Puestoslist.puestos, "rows": rowsData.positions };
        // console.log(rowsData.raise !== null);
        if (rowsData.raise !== null) {
          setRaiseIsnew(false);
          setRaise(rowsData.raise.monto);
          setRaiseId(rowsData.raise.id);
        }else{
        }
        setData(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setIsLoading(false)
    };

    fetchData();
  }, []); 
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (raiseIsnew === true) {
        const idaumento = await httpPost('/mod', { monto_q: raise, periodo: '20242025' });
        setRaiseIsnew(false);
        setRaiseId(idaumento);
      } else {
        await httpPUT(`/mod/${raiseId}`, { cost: raise });
        setMessage('Actualizado correctamente');
        setStatus('updated');
      }
      // Re-fetch the data to update the table and totals
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  
  document.title = "Mano de obra Directa - Ingreso puestos - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Mano de obra directa" title="Ingreso planilla"  />

          <Row>
          <Col className="col-2">
            <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="raise">Aumento anual</Label>
                      <Input
                        type="text"
                        id="raise"
                        placeholder="%"
                        value={ raise}
                        onChange={(e) => setRaise(e.target.value)}
                        required
                      />
                    </FormGroup>
                    <Button type="submit" color="primary">
                      {raiseIsnew === true ? 'Crear aumento' : 'Actualizar aumento'}
                    </Button>
                  </Form>
            </Col>
            <Col className="col-12">
              <Card>
                <CardBody>
                    <Dropzone onDrop={handleAcceptedFiles}>
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone-container">
                          <div className="btn btn-success dropzone  me-5 " {...getRootProps()}>
                            <input {...getInputProps()} />
                            <span>Subir presupuesto planilla por puestos</span>
                          </div>
                          {isUploading && <div className="upload-loader">Uploading...</div>}
                          {uploadResult && (
                            <div className="upload-check">
                              <i className="bx bx-check-circle"></i>
                            </div>
                          )}
                        </div>
                      )}
                    </Dropzone>

                <Button color="light" className="mi-5" onClick={downloadTemplate}>
                  <i className="bx bx-download me-1"></i> Descargar Plantilla (.xlsx)
                </Button>
                
                {<DataLoader isLoading={isLoading} data={data} />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PuestosCarga;
